import { RunGroupFormValues } from "@features/run/RunGroupDialog/RunGroupForm"
import { Checkbox, FormControl, FormControlLabel } from "@mui/material"
import { Controller, useFormContext } from "react-hook-form"

export const RunGroupFieldValidate = () => {
  const { control } = useFormContext<RunGroupFormValues>()
  return (
    <Controller
      name="validate"
      control={control}
      render={({ field }) => {
        return (
          <FormControl>
            <FormControlLabel
              control={<Checkbox {...field} />}
              label="Run post-validations (if defined)"
            />
          </FormControl>
        )
      }}
    />
  )
}
